import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import toast from "react-hot-toast";
import RouteIcon from "@mui/icons-material/Route";
import CancelIcon from "@mui/icons-material/Cancel";
import TerrainIcon from "@mui/icons-material/Terrain";
import TimelineIcon from "@mui/icons-material/Timeline";
import { handleError } from "../../../../utils/handleError";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewRoute,
  getRoutesAPI,
} from "../../../../services/rest/routes/routesServices";
import { setlistRoutes } from "../../../../redux/slice/routeSlice";
import { formatDistance } from "../../../../utils/formatDistance";

const ModalCloneRoute = ({
  open,
  setOpen,
  setLoading,
  setShowModalLimitRoutes,
  selectedRoute,
}) => {
  const { planName, routeLimit } = useSelector(
    (state) => state.membershipReducer
  );
  const { totalOfRoutes } = useSelector((state) => state.routeReducer);

  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  const dispatch = useDispatch();

  const cloneRoute = useCallback(async () => {
    try {
      //   Se  valida si la membresia de la ruta es compatible con la del usuario

      if (planName !== selectedRoute?.membershipType) {
        // console.log(
        //   "Mi membresia:",
        //   planName,
        //   "Membresia de ruta:",
        //   selectedRoute?.membershipType
        // );

        toast.error(
          `No pudimos clonar la ruta. \n Su membresia no es compatible. `
        );
        setLoading(false);
        return;
      }

      setLoading(true);
      const formatRouteData = { ...selectedRoute };
      delete formatRouteData._id;
      delete formatRouteData.membershipType;
      delete formatRouteData.isPublic;
      delete formatRouteData.createdAt;

      if (totalOfRoutes >= routeLimit) {
        setShowModalLimitRoutes(true);
        toast.error(
          `Has alcanzado el limite de rutas. \n Tu plan actual solo permite ${routeLimit} rutas.`
        );
        setOpen(false);
        setLoading(false);
        return;
      }
      await addNewRoute(formatRouteData);
      const listRoutes = await getRoutesAPI();
      dispatch(setlistRoutes({ listRoutes: listRoutes }));
      toast.success("Se creo con éxito la ruta");
      handleClose();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(`No pudimos clonar la ruta en estos momentos. \n ${message}`);
    }
  }, [handleClose, setLoading, selectedRoute]);

  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center", fontSize: 24 }}>
            Guardar en mi lista de Rutas
          </Typography>
          <Typography sx={{ textAlign: "center" }} className="text-primary ">
            Ruta con membresía{" "}
            {selectedRoute?.membershipType ?? "Sin membresía"}
          </Typography>
        </DialogTitle>
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography className="text-primary fs-2">
            {selectedRoute?.nameRoute ?? "Seleccione una ruta"}
          </Typography>
          <Typography>
            {selectedRoute?.description ?? "Seleccione una ruta"}
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Distancia</Typography>
              </Box>
              <Typography>
                {formatDistance(selectedRoute?.distance) ?? 0}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TimelineIcon className="text-primary " />
                <Typography>Dificultad</Typography>
              </Box>
              <Typography>{selectedRoute?.difficulty ?? ""}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TerrainIcon className="text-primary " />
                <Typography>Terreno</Typography>
              </Box>
              <Typography>{selectedRoute?.terrainType ?? ""}</Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{ borderColor: "white", color: "white" }}
            onClick={handleClose}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
          <Button
            variant="contained"
            onClick={cloneRoute}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<RouteIcon />}
          >
            Guardar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCloneRoute;
